import {
	Button,
	Flex,
	Icon,
	PopoverParts,
} from "src/components";
import { APP_CONFIG, TRANSLATION } from "src/models/constants";
import { useUserName } from "src/datahandling/hooks";
import { logoutInsightsLive } from "src/authentication-and-logging/authAndLogger";
import styling from "./Header.module.scss";
import { CompanySelector } from "./CompanySelector/CompanySelector";
import { useTranslation } from "react-i18next";
import { useCustomerSettingsContext } from "src/contexts";

export const Header = () => {
	// *****************************************
	// Properties
	// *****************************************

	const { setTheme, theme } = useCustomerSettingsContext();
	const username = useUserName();
	const { t } = useTranslation([TRANSLATION.COMMON]);

	// *****************************************
	// Render
	// *****************************************

	return (
		<Flex.Row
			render={<header />}
			alignment="center-left"
			justifyContent="space-between"
			className={styling["header-wrapper"]}
			width="100%"
		>
			<Flex.Row
				render={<nav />}
				alignment="center-left"
				className={styling.left}
				gap="2xlarge"
				width="50%"
			>
				<Button
					href="/"
					variant="ghost"
					color="neutral"
					leftIcon={<Icon className={styling["logo--icon"]} name="ProductsKnowledger" size="small" />}
					className={styling.logo}
					text={APP_CONFIG.appName}
				/>
			</Flex.Row>
			<Flex.Row
				render={<nav />}
				alignment="center-right"
				className={styling.right}
				gap={"2xlarge"}
				width="50%"
			>
				<Button
					leftIcon={<Icon name="LargeNotifications" />}
					paddingRule="icon-only"
					color="neutral"
					variant="ghost"
					size="medium"
				/>
				<CompanySelector />
				<PopoverParts.Root>
					<PopoverParts.Avatar
						color={"action"}
						variant={"ghost"}
						className={styling["avatar-trigger"]}
						text={username ?? ""}
						fallback={username ?? ""}
						size="large"
						avatar={{
							color: "teal",
							size: "small"
						}}
					/>
					<PopoverParts.Content padded>
						<PopoverParts.Item
							color="neutral"
							variant={"ghost"}
							leftIcon={<Icon size="large" name="LargeSettingsGlobal" />}
							href="/settings"
						>
							{t("COMMON:features.settings")}
						</PopoverParts.Item>
						<PopoverParts.Item
							color="neutral"
							variant={"ghost"}
							leftIcon={<Icon size="large" name="LargeLogout" />}
							onClick={() => logoutInsightsLive()}
						>
							{t("COMMON:log-out")}
						</PopoverParts.Item>
						<PopoverParts.Item
							color="neutral"
							variant={"ghost"}
							leftIcon={
								<Icon
									size="large"
									name="LargeSunny"
								/>
							}
							onClick={() => setTheme(theme === "light" ? "dark" : "light")}
						>
							{t("COMMON:change-theme")}
						</PopoverParts.Item>
					</PopoverParts.Content>
				</PopoverParts.Root>
			</Flex.Row>
		</Flex.Row>
	);
};
